(() => {
  const selector = '.ProductCardSwitcher [data-tooltip], [data-ui-tooltip]';
  const wishlistSelector = '.mib-global-wishlist-btn, .mib-wishlist-btn';
  let activeTrigger = null;
  let hideTimer = null;
  let touchTrigger = null;
  const tooltip = document.createElement('div');
  tooltip.id = 'ui-tooltip';
  tooltip.className = 'UiTooltip';
  tooltip.setAttribute('role', 'tooltip');
  tooltip.hidden = true;
  document.body.append(tooltip);

  const hideTooltip = () => {
    if (activeTrigger) {
      activeTrigger.removeAttribute('data-tooltip-visible');
      const descriptions = (activeTrigger.getAttribute('aria-describedby') || '')
        .split(/\s+/).filter((id) => id && id !== tooltip.id);
      if (descriptions.length) activeTrigger.setAttribute('aria-describedby', descriptions.join(' '));
      else activeTrigger.removeAttribute('aria-describedby');
    }
    activeTrigger = null;
    tooltip.hidden = true;
    window.clearTimeout(hideTimer);
  };

  const positionTooltip = () => {
    if (!activeTrigger?.isConnected) return hideTooltip();
    const triggerRect = activeTrigger.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();
    const gap = 8;
    const margin = 8;
    const below = activeTrigger.hasAttribute('data-ui-tooltip');
    let top = below ? triggerRect.bottom + gap : triggerRect.top - tooltipRect.height - gap;
    if (top + tooltipRect.height > window.innerHeight - margin) top = triggerRect.top - tooltipRect.height - gap;
    if (top < margin) top = triggerRect.bottom + gap;
    const left = Math.max(margin, Math.min(
      triggerRect.left + (triggerRect.width - tooltipRect.width) / 2,
      window.innerWidth - tooltipRect.width - margin
    ));
    tooltip.style.left = left + 'px';
    tooltip.style.top = Math.max(margin, top) + 'px';
  };

  const showTooltip = (trigger) => {
    if (!trigger.dataset.tooltip) return;
    if (activeTrigger !== trigger) hideTooltip();
    activeTrigger = trigger;
    tooltip.textContent = trigger.dataset.tooltip;
    tooltip.hidden = false;
    trigger.setAttribute('data-tooltip-visible', '');
    const descriptions = new Set((trigger.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
    descriptions.add(tooltip.id);
    trigger.setAttribute('aria-describedby', Array.from(descriptions).join(' '));
    positionTooltip();
  };

  const syncWishlist = (button) => {
    if (!button.matches(wishlistSelector)) return;
    const active = button.getAttribute('data-mib-wishlist-active') === 'true';
    const label = active ? button.dataset.wishlistRemoveLabel : button.dataset.wishlistAddLabel;
    if (!label) return;
    button.setAttribute('data-ui-tooltip', '');
    button.setAttribute('aria-label', label);
    button.dataset.tooltip = label;
    if (button === activeTrigger) {
      tooltip.textContent = label;
      positionTooltip();
    }
  };

  const syncTree = (root) => {
    if (!(root instanceof Element)) return;
    syncWishlist(root);
    root.querySelectorAll(wishlistSelector).forEach(syncWishlist);
  };
  syncTree(document.documentElement);
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes') syncWishlist(mutation.target);
      else mutation.addedNodes.forEach(syncTree);
    });
    if (activeTrigger && !activeTrigger.isConnected) hideTooltip();
  });
  observer.observe(document.documentElement, {
    subtree: true, childList: true, attributes: true,
    attributeFilter: ['data-mib-wishlist-active']
  });

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse') return;
    const trigger = event.target.closest(selector);
    if (!trigger || trigger.contains(event.relatedTarget) || trigger.hasAttribute('data-tooltip-dismissed')) return;
    showTooltip(trigger);
  });
  document.addEventListener('pointerout', (event) => {
    const trigger = event.target.closest(selector);
    if (!trigger || trigger.contains(event.relatedTarget)) return;
    if (activeTrigger === trigger) hideTooltip();
    trigger.removeAttribute('data-tooltip-dismissed');
  });
  document.addEventListener('focusin', (event) => {
    const trigger = event.target.closest(selector);
    if (!trigger || !trigger.matches(':focus-visible') || trigger.hasAttribute('data-tooltip-dismissed')) return;
    showTooltip(trigger);
  });
  document.addEventListener('pointerup', (event) => {
    if (event.pointerType === 'mouse') return;
    const trigger = event.target.closest(selector);
    if (!trigger) return hideTooltip();
    touchTrigger = trigger;
    trigger.removeAttribute('data-tooltip-dismissed');
    showTooltip(trigger);
    window.clearTimeout(hideTimer);
    hideTimer = window.setTimeout(() => { hideTooltip(); touchTrigger = null; }, 1800);
  }, { passive: true });
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(selector);
    if (!trigger) return hideTooltip();
    if (trigger === touchTrigger && event.detail > 0 && trigger.hasAttribute('data-ui-tooltip')) return;
    touchTrigger = null;
    hideTooltip();
    trigger.setAttribute('data-tooltip-dismissed', '');
  });
  document.addEventListener('product-card:changed', hideTooltip);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    activeTrigger?.setAttribute('data-tooltip-dismissed', '');
    hideTooltip();
  });
  document.addEventListener('focusout', (event) => {
    const trigger = event.target.closest(selector);
    if (!trigger) return;
    if (activeTrigger === trigger) hideTooltip();
    trigger.removeAttribute('data-tooltip-dismissed');
  });
  document.addEventListener('scroll', hideTooltip, true);
  window.addEventListener('resize', hideTooltip);
})();
